/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const TableBox = styled.div`
  width: 100%;
  background-color: white;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-radius: 0px 0px 4px 4px;
  margin-bottom: 100px;
`;

export const TableFooter = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  padding: 12px;
  color: ${Palette.PrimaryGray._500};
  background-color: ${Palette.PrimaryGray._000};
  border-top: 1px solid ${Palette.PrimaryGray._200};
`;

export const FooterBody = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  padding: 10px;
  border-left: 1px solid ${Palette.PrimaryGray._200};

  span {
    color: ${Palette.PrimaryGray._700};
  }
`;

export const ProgressBar = styled.div`
  position: relative;
  width: 64px;
  height: 4px;
  border-radius: 4px;
  background-color: ${Palette.PrimaryGray._200};
  overflow: hidden;

  ::before {
    content: ' ';
    position: absolute;
    height: 100%;
    width: ${({ status }) => `${status}%`};
    background-color: ${Palette.Primary._300};
  }
`;

export const FooterBtn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-right: 6px;
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  border-radius: 4px;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'auto')};
  pointer-events: ${({ isActive }) => (isActive ? 'auto' : 'none')};

  &:hover {
    color: ${Palette.PrimaryGray._700};
    background-color: ${Palette.Primary._000};
  }
`;
